var spcColors = {
  black: {
    0: '#000000',
    1: '#212121',
    2: '#2B2B2C',
    3: '#345464',
    4: '#242427'
  },
  gray: {
    1: '#859AA6',
    2: '#91A4AF',
    3: '#D9E6ED',
    4: '#EAEFF1',
    5: '#F1F1F2'
  },
  white: {
    1: '#FFFFFF',
    2: '#F9FCFD',
    3: '#FCFEFE'
  },
  negative: {
    1: '#F43A3A',
    2: '#FE6762'
  },
  positive: {
    1: '#149469',
    2: '#7FF0BA'
  },
  accent: {
    1: '#6CA2FF',
    2: '#3B824A'
  },
  warning: {
    1: '#DF951F',
    2: '#FFB641'
  },
  dark: {
    1: '#333536',
    2: '#242425',
    3: '#1C1C1C',
    4: '#1A1919',
    5: '#1A1A1A',
    6: '#262626'
  },
  light: {
    1: '#F8F8F8',
    2: '#F1F1F2',
    3: '#DBDEE1',
    4: '#EEF0F0'
  }
};
export default spcColors;